import { FunctionComponent } from "enzyme";
import { IconProps } from "./constants";

const IconMoney: FunctionComponent<IconProps> = ({ width = "22", height = "22", className = "", name = "money" }) => {
  return (
    <svg
      data-name={name}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.001" cy="11" r="9.75" stroke="#305953" strokeWidth="2.5" />
      <circle cx="11.001" cy="11" r="9.75" stroke="black" strokeOpacity="0.2" strokeWidth="2.5" />
      <path
        d="M13.4989 8.28695V8.28695C13.4989 7.15982 12.5852 6.24609 11.458 6.24609H10.4376C9.22996 6.24609 8.25098 7.22508 8.25098 8.43273V8.43273C8.25098 9.64037 9.22997 10.6194 10.4376 10.6194H11.3123C12.5199 10.6194 13.4989 11.5983 13.4989 12.806V12.806C13.4989 14.0136 12.5199 14.9926 11.3123 14.9926H10.2918C9.1647 14.9926 8.25098 14.0789 8.25098 12.9518V12.9518"
        stroke="#305953"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.4989 8.28695V8.28695C13.4989 7.15982 12.5852 6.24609 11.458 6.24609H10.4376C9.22996 6.24609 8.25098 7.22508 8.25098 8.43273V8.43273C8.25098 9.64037 9.22997 10.6194 10.4376 10.6194H11.3123C12.5199 10.6194 13.4989 11.5983 13.4989 12.806V12.806C13.4989 14.0136 12.5199 14.9926 11.3123 14.9926H10.2918C9.1647 14.9926 8.25098 14.0789 8.25098 12.9518V12.9518"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M10.876 6.24688V4.40039" stroke="#305953" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.876 6.24688V4.40039" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.876 16.8406V14.9941" stroke="#305953" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.876 16.8406V14.9941" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default IconMoney;
